import { ChakraProvider } from '@chakra-ui/react'
import type React from 'react'

import { theme } from '@/styles/theme'

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return <ChakraProvider value={theme}>{children}</ChakraProvider>
}
